import { for_farmers_ru } from './forFarmers'
import { detailsAboutSlide_ru } from './detailsAboutSlide'
import { labs_ru } from './labs'
import { footerFormRu } from './footerForm'
import { consulting_ru } from './consulting'
import { products_ru } from './products'
import { trading_ru } from './trading'
import { ru_testing } from './testing'

const ru = {
    search: 'Поиск',
    aboutCompany: 'О компании',
    news: 'Новости',
    production: 'Продукция',
    productionLower: 'продукция',
    catalog: 'Каталог',
    contacts: 'Контакты',
    productions: 'Производства',
    partners: 'Партнерам',
    megakorm: 'Мегакорм',
    megamix: 'Мегамикс',
    Megamix: 'МегаМикс',
    details: 'Подробнее',
    farmers: 'Фермерам',
    laboratories: 'Лаборатории',
    vacancy: 'Вакансии',
    megamixForFarmers: 'Мегамикс фермерам',
    productsIngredientsAdditivesAndFeedSolutions: 'Продукты: компоненты, добавки и кормовые решения',
    products: 'Продукты',
    consulting: 'Консалтинг',
    laboratoriesP: 'Личный кабинет',
    trading: 'Продажи сырья',
    export: 'Экспорт',
    labs: 'Лабораторные исследования',
    aboutUs: 'О нас',
    Technologies: 'Технологии',
    clients: 'Клиентам',
    weFeedThoseWhoFeedUs: 'Кормим тех,',
    weFeedThoseWhoFeedUs1: 'кто кормит нас',
    ecosystemOfMEGAMIXGROUP:
        'Экосистема ГК МЕГАМИКС - крупнейшего производителя премиксов, комбикормов и белково-витаминно-минеральных добавок для всех видов сельскохозяйственных животных и птиц',
    learnMore: 'Узнать больше',
    aboutCompany: 'О компании',
    aboutCompanyLower: 'о компании',
    forCustomers: 'клиентам',
    customOrder: 'Индивидуальный заказ',
    customOrderText: `Мы являемся лидерами в производстве премиксов и поставке компонентов на отечественном рынке. Для крупных заказчиков компания "Мегамикс" готова выполнить заказ по индивидуальной рецептуре, исходя из имеющейся сырьевой базы клиента. Среди преимуществ нашей компании - наличие собственной научной и технологической базы, которое позволяет произвести правильные расчеты и реализацию различных задач, а также широкие логистические возможности.`,
    customOrderText1: `Производственные точки и объекты хранения компонентов ГК МЕГАМИКС соответствуют мировым стандартам, что гарантирует высокое качество выпускаемой продукции. Для того, чтобы сделать индивидуальный заказ, заполните, пожалуйста, форму обратной связи или свяжитесь с нами по телефону.`,
    sendEnquiry: 'Отправить заявку',
    eventsTitle: 'Календарь событий',
    upcomingEvents: 'ближайшие события',
    featuringMegamix: 'с участием Мегамикс',
    newsTitle: 'Новости',
    usefulMaterialsTitle: 'Полезные материалы',
    Feedback: 'Обратная связь',
    distributors: 'дистрибьютеры',
    footerText:
        'У нас более 200 дистрибьютеров по всей России и ближайшему зарубежью. Найти подходящего дистрибьютера можно на сайте нашей основной продуктовой линейки.',
    onMegakorm: 'На сайте Мегакорм',
    weAreInTouch: 'Мы на связи с понедельника по пятницу, с 9:00 до 17:00. Вы можете',
    orderACall: 'заказать звонок',
    WeAreReadyToAcceptYourRequestByMail: 'Готовы принять ваше обращение по почте',
    DownloadPressKit: 'Скачать пресс-кит, 18 мб',
    PressService: 'Пресс-служба',
    FeedbackText:
        'Определились с заказом или требуется дополнительная информация? Свяжитесь с нами, заполнив форму обратной связи, для получения всех необходимых консультаций и оперативного сопровождения заказа.',
    send: 'Отправить',
    megamixB2B: 'Мегамикс b2b',
    LegalInformation: 'Сертификаты',
    PersonalDataProcessing: 'Политика обработки персональных данных',
    MegamixGroup: `Группа компаний "Мегамикс"`,
    BackToMap: 'Назад к карте',
    b2bText1:
        'Группа компаний «Мегамикс» объединяет в себе надежность, инновации и профессионализм в сфере производства премиксов, кормовых добавок, бвмк и комбикормов.',
    b2bText2:
        'Наши клиенты - это не просто предприятия, это партнеры, сотни компаний, включая как крупные агрохолдинги, так и предприятия среднего бизнеса, как в России, так и за рубежом. Мы гордимся тем, что с нашими продуктами и решениями наши партнеры достигают новых высот производства и результативности.',
    MegamixToday: 'Мегамикс сегодня',
    bestInRussia: '№1 в России',
    bestInRussiaAbout: 'Крупнейший производитель премиксов в России и один из крупнейших в Европе',
    productionsCount: '6 производств',
    productionsCountAbout: '6 производственных площадок, работающих по международным стандартам',
    percentInRussia: '32% российского рынка',
    percentInRussiaAbout: '32% комбикормов в РФ производятся на основе премиксов Мегамикс',
    percentGlobal: '1% мирового рынка',
    percentGlobalAbout: '1% мирового рынка кормов для животных',
    WorldsFirstVitE60: '1-й в мире сухой E 60%',
    WorldsFirstVitE60About: 'Первый в мире производитель сухого кормового витамина Е 60%',
    LaboratoriesCount: '3 лаборатории',
    LaboratoriesCountAbout: '3 аккредитованные научные лаборатории',
    OfficesCount: '7 офисов',
    OfficesCountAbout: '7 офисов в центральных городах России',
    gmpPlus: 'GMP+',
    gmpPlusAbout: 'Первая в России премиксная компания, сертифицированная по системе GMP+',
    megamixGroupb2bCardText:
        'ГК МЕГАМИКС представляет собой объединение двух современных премиксных заводов, двух комбикормовых заводов и агрохолдинга CHUVA. Это обеспечивает нашим партнерам доступ к широкому спектру продукции и услуг, покрывающему все аспекты сельскохозяйственного производства.',
    ExpertSupportTitle: 'Экспертная поддержка',
    ExpertSupportText:
        'Непрерывные исследования и разработки: Наш отдел исследований и разработки постоянно работает над улучшением ассортимента и качества нашей продукции. Мы используем передовые технологии и знания, чтобы предложить нашим клиентам инновационные решения, отвечающие их потребностям.',
    HighQualityTitle: 'Высокое качество',
    HighQualityText:
        'Система полной прослеживаемости сырья и готовой продукции является одним из ключевых преимуществ ГК МЕГАМИКС. Компания гарантирует точность смешивания продукции в соотношении 1:100 000, что обеспечивает высокое качество конечного продукта.',
    EfficientLogisticsTitle: 'Эффективная логистика',
    EfficientLogisticsText:
        'Наш собственный логистический комплекс обеспечивает своевременную поставку продукции партнерам. Это позволяет оптимизировать процесс доставки и минимизировать риски задержек, что является важным фактором для наших партнеров.',
    ContinuousRDTitle: 'Непрерывные исследования и разработки',
    ContinuousRDText:
        'Эффективная логистика: Наш собственный логистический комплекс обеспечивает своевременную поставку продукции партнерам. Это позволяет оптимизировать процесс доставки и минимизировать риски задержек, что является важным фактором для наших партнеров.',
    ReliabilityAndStabilityTitle: 'Надежность и стабильность',
    ReliabilityAndStabilityText:
        'ГК МЕГАМИКС - это надежный и стабильный партнер, готовый поддерживать ваш бизнес в любых условиях. Мы стремимся к долгосрочным отношениям, основанным на взаимном доверии и взаимовыгодном сотрудничестве.',
    LargePortfolioTitle: 'Широкий ассортимент и высокая производственная мощность',
    LargePortfolioText:
        'Кормовая компания «Мегамикс» обладает огромной производственной мощностью, способной удовлетворить потребности любого животноводческого комплекса или птицефабрики. Наш завод в Липецкой области производит до 180 000 тонн ежегодно, что соответствует 900 мешкам каждый час.',
    history: 'история',
    History: 'История',
    mission: 'миссия',
    Mission: 'Миссия',
    strategy: 'стратегия',
    Strategy: 'Стратегия',
    video: 'видео',
    Video: 'Видео',
    gallery: 'галерея',
    Gallery: 'Галерея',
    toWebsiteButton: 'На сайт',
    Megaschool: 'Мегашкола',
    watch_on_Youtube: 'Смотреть',
    Megakorm_website: 'На сайт Мегакорм',
    catalogSwiperCircle: 'Каталог Каталог Каталог Каталог Каталог',
    materialsSwiperCircle: 'Материалы Материалы Материалы',
    searchErrorMessage: 'По данному запросу ничего не найдено.',
    loadingProcess: 'Загрузка...',
    loadMore: 'Загрузить еще',
    watchAll: 'смотреть все',
    resetAll: 'Сбросить все',
    specializations: 'Специализации',
    allSpecializations: 'Все специализации',
    search: 'Поиск',
    photoReport: 'Фото-отчет',
    videoReport: 'Видео-отчет',
    otherNews: 'Другие новости',
    readAll: 'читать все',
    moreDetailedTest: 'Подробнее',
    externalLinks: 'внешние ссылки',
    BackToCatalog: 'Назад к каталогу',
    PurposeOfProduct: 'Назначение',
    ProductComposition: 'Состав',
    ProductApplication: 'Применение',
    Vacancies: 'Вакансии',
    release: 'выпуск',
    cookie: 'Мы используем cookie для корректной работы сайта, улучшения сервиса и анализа посещаемости. Нажимая «Принять», вы :соглашаетесь: на их использование. :Подробнее:',
    ok: 'Принять',
    reject: 'Отклонить',agree: 'согласен',
    agree1: 'Я даю',
    agree3: ' согласие',
    agree4: ' на обработку персональных данных и соглашаюсь с условиями',
    agree2: ' Политики обработки и защиты персональных данных',
    office: 'Офисы',
    ...for_farmers_ru,
    ...detailsAboutSlide_ru,
    ...labs_ru,
    ...footerFormRu,
    ...consulting_ru,
    ...products_ru,
    ...trading_ru,
    ...ru_testing
}

export default ru
